import PropTypes from 'prop-types';
import React from 'react';
import {View} from 'react-native';

const FilledDoughnut = props => {
  const {size} = props;
  return (
    <View style={{
      width: size,
      height: size,
      borderRadius: size / 2,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#FFFFFF', // Pure white core
      // Subtle inner border for definition
      borderWidth: 0.5,
      borderColor: '#E0E0E0',
      overflow: 'hidden',
    }}>
      {props.children}
    </View>
  );
};

export default FilledDoughnut;